import type { Dayjs } from 'dayjs'

import { LOCALE } from '@/legacy-src/constants/locale.constants'

/** Intl, not dayjs: the cs locale renders "1. říjen" where Czech needs the genitive "1. října". */
const formatLocalized = (date: Dayjs, options: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat(LOCALE, options).format(date.toDate())

export const formatMonth = (date: Dayjs) => formatLocalized(date, { month: 'long' })

export const formatMonthYear = (date: Dayjs) => formatLocalized(date, { month: 'long', year: 'numeric' })

export const formatMonthDay = (date: Dayjs) => formatLocalized(date, { day: 'numeric', month: 'long' })

export const formatShortMonthDay = (date: Dayjs) => formatLocalized(date, { day: 'numeric', month: 'short' })

export const formatMonthDayYear = (date: Dayjs) =>
  formatLocalized(date, { day: 'numeric', month: 'long', year: 'numeric' })

export const formatWeekdayDate = (date: Dayjs) =>
  formatLocalized(date, { weekday: 'long', day: 'numeric', month: 'numeric' })
